<template>
  <section class="sim-section" id="simSection">
    <div class="container">
      <div class="sim-image-container"></div>
      <div class="sim-text-container">
        <div class="about">
          <div class="about__heading">
            <span>№4</span> eSim стала <br>реальностью
          </div>
          <div class="about__text">
            В новом году пластиковой SIM-карте исполнится
            30 лет! А в 2020-м МТС начала подключать eSIM —
            SIM-карты без пластика. Новую eSIM можно
            активировать даже без посещения салонов связи
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { gsap } from 'gsap';

export default {
  name: 'v-sim-section',
  mounted() {
    const timelineSim = gsap.timeline({
      scrollTrigger: {
        trigger: '.sim-section',
        start: '-=65%',
        end: '30%',
        scrub: 1,
        onUpdate: (self) => {
          console.log('progress8:', self.progress);
          document.body.style.background = '#F4F4F4';
          // const simSection = document.getElementById('simSection');
          // if (self.progress > 0.1 && !simSection.classList.contains('active')) {
          //   simSection.classList.add('active');
          //   TweenMax.to('.sim-image-container', {
          //     duration: 1,
          //     backgroundPositionX: '118%',
          //   });
          // }
          // if (self.progress < 0.1 && simSection.classList.contains('active')) {
          //   simSection.classList.remove('active');
          //   TweenMax.to('.sim-image-container', {
          //     duration: 1,
          //     backgroundPositionX: '0%',
          //   });
          // }
        },
      },
    });
    timelineSim.addLabel('start')
      .to('.sim-image-container', {
        duration: 1,
        backgroundPositionX: '116%',
      })
      .to('.sim-image-container', {
        duration: 2,
        backgroundSize: '630%',
      })
      .to('.sim-image-container', {
        duration: 1,
        backgroundPositionX: '88%',
      }, '-=2')
      .to('.sim-image-container', {
        duration: 1,
        backgroundPositionX: '88%',
      });
  },
};
</script>

<style lang="scss">
.sim-section {
  position: relative;
  min-height: unset;

  .container {
    position: sticky;
    top: 20px;
    padding-top: 220px;
  }
}
.sim-image-container{
  width: 100%;
  height: 220px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 15;
  background-image: url("../assets/image/sim-section/sims.png");
  background-repeat: no-repeat;
  background-size: 200%;
  background-position: -14% center;

  &:after, &:before{
    content: '';
    display: block;
    position: absolute;
    width: 20%;
    height: 100%;
  }

  &:before{
    background: linear-gradient(90deg, #F4F4F4 50%, rgba(244, 244, 244, 0) 100%);
    left: 0;
  }

  &:after{
    background: linear-gradient(-90deg, #F4F4F4 50%, rgba(244, 244, 244, 0) 100%);
    right: 0;
  }
}
</style>
